import * as React from 'react';
import {connect} from 'react-redux';
import {
    GetPointsFromReference,
    getPointsFromReference,
    setAnchorPoint,
    SetAnchorPoint,
    setListenForAnchorPoint,
    SetListenForAnchorPoint,
    setUseAnchors,
    SetUseAnchors
} from '../actions';
import * as selectors from '../selectors';
import LocationalState, {AnchorPoint, SelectedLocalizationType} from '../LocationalState';
import {Button} from 'react-bootstrap';
import classNames = require('classnames');
import datafangstHelpers from '../../../../utilities';

interface DispatchProps {
    doSetUseAnchors: SetUseAnchors;
    doSetListenForAnchorPoint: SetListenForAnchorPoint;
    doGetAnchorPoints: GetPointsFromReference;
    setAnchorPoint: SetAnchorPoint;
}

interface StateProps {
    useAnchors: boolean;
    listenForAnchorPoint: AnchorPoint;
    startAnchorSet: boolean;
    endAnchorSet: boolean;
    selectedLocalizationType: SelectedLocalizationType;
    fetchingPointsFromReference: boolean;
}


type Props = StateProps & DispatchProps;

const mapStateToProps = (state: LocationalState): StateProps => {
    return {
        useAnchors: selectors.useAnchors(state),
        listenForAnchorPoint: selectors.listenForAnchorPoint(state),
        startAnchorSet: selectors.startAnchorIsSet(state),
        endAnchorSet: selectors.endAnchorIsSet(state),
        selectedLocalizationType: selectors.selectedLocalizationType(state),
        fetchingPointsFromReference: selectors.fetchingPointsFromReference(state)
    };
};

const mapDispatchToProps: DispatchProps = ({
    doSetUseAnchors: setUseAnchors,
    doSetListenForAnchorPoint: setListenForAnchorPoint,
    doGetAnchorPoints: getPointsFromReference,
    setAnchorPoint
});

type ControlPickedProps = Pick<Props,
    | 'selectedLocalizationType'
    | 'doSetListenForAnchorPoint'
    | 'doGetAnchorPoints'
    | 'startAnchorSet'
    | 'endAnchorSet'
    | 'fetchingPointsFromReference'
    | 'useAnchors'
    | 'setAnchorPoint'>;

interface ControlsState {
    error: string;
    bError: string;
    systemRefPointA: string;
    systemRefPointB: string;
    valid: boolean;
    showBInput: boolean;
}

class Controls extends React.Component<ControlPickedProps, ControlsState > {

    constructor(props: ControlPickedProps) {
        super(props);
        this.state = {
            error: '',
            bError: '',
            systemRefPointA: '',
            systemRefPointB: '',
            valid: true,
            showBInput: false
        };
        this.handleSystemRefChange = this.handleSystemRefChange.bind(this);
        this.handleBRefChange = this.handleBRefChange.bind(this);
        this.resetState = this.resetState.bind(this);
        this.handleGetAnchorPoints = this.handleGetAnchorPoints.bind(this);
    }

    render() {
        const startButtonClasses = classNames({
            'btn': true,
            'is-set': this.props.startAnchorSet
        });
        const endButtonClasses = classNames({
            'btn': true,
            'is-set': this.props.endAnchorSet
        });
        const vegSystemRefInputContainer = classNames({
            'vegsystemInput': true
        });

        const selectedLocalizationType = this.props.selectedLocalizationType;
        switch (selectedLocalizationType) {
            case SelectedLocalizationType.NONE:
                return <p>Velg ett eller flere vegobjekter for å sette stedfesting.</p>;
            case SelectedLocalizationType.MIXED:
                return <p>Velg kun vegobjekter med samme type stedfesting</p>;
            case SelectedLocalizationType.POINT:
                return <>
                    <section className={vegSystemRefInputContainer}>
                        <input defaultValue={''} id={'systemRef'} onChange={this.handleSystemRefChange} type={'text'} placeholder={'Vegsystemreferanse'} />
                        {(this.state.error.length > 0 || (this.state.valid && this.state.systemRefPointA.length > 0)) && <label htmlFor={'systemRef'}>{this.state.error}</label>}
                        {this.state.systemRefPointA.length > 0
                            ? <>
                                <p>Punkt: {this.state.systemRefPointA}</p>
                                <Button disabled={this.props.fetchingPointsFromReference} onClick={this.handleGetAnchorPoints}>Fest punkt på kartet</Button>
                            </>
                            : null}
                    </section>
                    {
                        this.state.systemRefPointA.length > 0
                            ? null
                            : <><p>Eller angi punkt på veg som skal brukes som stedfesting.</p>
                                <div className={'anchorsTool--buttons'}>
                                    <button className={startButtonClasses} onClick={() => this.listenForAnchorPoint(AnchorPoint.start)}>Punkt</button>
                                </div></>
                    }
                </>;
            case SelectedLocalizationType.LINE:
                return <>
                    <input defaultValue={''} id={'systemRef'} className={vegSystemRefInputContainer} onChange={this.handleSystemRefChange} type={'text'} placeholder={'Vegsystemreferanse'} />
                    {this.state.error.length > 0 && <label htmlFor={'systemRef'}>{this.state.error}</label>}
                    {
                        this.state.showBInput && (
                            <>
                                <input defaultValue={this.state.systemRefPointB} placeholder={'Sluttpunkts referanse'} id={'systemRefB'} className={vegSystemRefInputContainer} onChange={this.handleBRefChange} type={'text'}/>
                                {this.state.bError.length > 0 && <label htmlFor={'systemRefB'}>{this.state.bError}</label>}
                            </>
                        )
                    }
                    {
                        this.state.systemRefPointA.length > 0 && this.state.systemRefPointB.length > 0
                            ? <>
                                <p>Startpunkt: {this.state.systemRefPointA}</p>
                                <p>Sluttpunkt: {this.state.systemRefPointB}</p>
                                <Button disabled={this.props.fetchingPointsFromReference} onClick={this.handleGetAnchorPoints}>Fest punkter på kartet</Button>
                            </>
                            :
                            <>
                                <p>Eller angi start- og sluttpunkt på veg for stedfesting.</p>
                                <div className={'anchorsTool--buttons'}>
                                    <button className={startButtonClasses} onClick={() => this.listenForAnchorPoint(AnchorPoint.start)}>Startpunkt</button>
                                    <button className={endButtonClasses} onClick={() => this.listenForAnchorPoint(AnchorPoint.end)}>Sluttpunkt</button>
                                </div>
                            </>
                    }
                </>;
            default:
                return null;
        }
    }

    handleGetAnchorPoints() {
        if (this.props.selectedLocalizationType === SelectedLocalizationType.POINT && this.state.systemRefPointA.length > 0) {
            this.props.doGetAnchorPoints(this.state.systemRefPointA);
        } else if (this.props.selectedLocalizationType === SelectedLocalizationType.LINE && this.state.systemRefPointA.length > 0 && this.state.systemRefPointB.length > 0) {
            this.props.doGetAnchorPoints(this.state.systemRefPointA, this.state.systemRefPointB);
        }
    }

    listenForAnchorPoint(anchorPoint: AnchorPoint) {
        this.props.doSetListenForAnchorPoint(anchorPoint);
    }

    componentDidUpdate(prevProps: Readonly<ControlPickedProps>, prevState: Readonly<ControlsState>) {
        if (prevProps.selectedLocalizationType !== this.props.selectedLocalizationType || prevProps.useAnchors && !this.props.useAnchors) {
            this.resetState();
        }
    }

    resetState() {
        this.props.setAnchorPoint(AnchorPoint.start, null);
        this.props.setAnchorPoint(AnchorPoint.end, null);
        this.setState({systemRefPointA: '', systemRefPointB: '', error: '', bError: '', valid: true, showBInput: false});
    }

    handleSystemRefChange(e: React.ChangeEvent<HTMLInputElement>) {
        const {trimmed, valid, error: validationError, before, a, b} = datafangstHelpers.extractInfoFromSystemRef(e.target.value);

        if (trimmed.length === 0) {
            this.resetState();
            return;
        }

        let error = validationError;
        const showBInput = this.props.selectedLocalizationType === SelectedLocalizationType.LINE && b === '';
        if (this.props.selectedLocalizationType === SelectedLocalizationType.POINT && b !== '') {
            error = 'NB: Punktreferansen dekker en strekning';
        }
        const {a: previousBText, error: bError} = datafangstHelpers.extractInfoFromSystemRef(this.state.systemRefPointB);
        const newState: any = {
            valid,
            error,
            bError: showBInput && this.state.systemRefPointB.length === 0
                ? 'NB: Linjereferansen må dekke en strekning'
                : bError,
            showBInput,
            systemRefPointA: valid
                ? `${before}${a}`
                : trimmed
        };
        if (b.length > 0) {
            newState.systemRefPointB = `${before}${['M', 'm'].includes(b.charAt(0)) ? '' : 'm'}${b}`;
        }
        this.setState(newState);
    }

    handleBRefChange(e: React.ChangeEvent<HTMLInputElement>) {
        const {valid, error, trimmed, before, a} = datafangstHelpers.extractInfoFromSystemRef(e.target.value);
        if (trimmed.length === 0) {
            this.props.setAnchorPoint(AnchorPoint.end, null);
        }
        this.setState({
            valid,
            error: '',
            bError: trimmed === '' ? 'NB: Linjereferansen må dekke en strekning' : error,
            systemRefPointB: valid ? `${before}${a}` : trimmed
        });
    }
}

class Component extends React.Component<Props, {}> {


    render() {
        const {useAnchors} = this.props;

        const toolClasses = classNames({
            'anchorsTool': true,
            'useAnchors': useAnchors
        });

        return (
            <div className={toolClasses}>
                <label>
                    <input type="checkbox" checked={useAnchors} onChange={() => this.toggleUseAnchors()}/> Angi stedfesting manuelt
                </label>
                <div className={'extended'}>
                    <Controls {...this.props}/>
                </div>
            </div>
        );
    }

    toggleUseAnchors() {
        this.props.doSetUseAnchors(!this.props.useAnchors);
    }

}

export const LocalizeManuallyTool = connect(mapStateToProps, mapDispatchToProps)(Component);